/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  PayoutMethods,
  PayoutMethodState
} from '@/store/interfaces/payoutMethod';
import { RootState } from '@/store/interfaces/rootState';
import payoutMethodType from '@/store/types/payoutMethod';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): PayoutMethodState => {
  return {
    payoutMethodsList: [],
  };
};

const state: PayoutMethodState = initialState();

const getters: GetterTree<PayoutMethodState, RootState> = {
  [payoutMethodType.getters.GET_PAYOUT_METHODS_LIST]: state => {
    return state.payoutMethodsList;
  },
};

const mutations: MutationTree<PayoutMethodState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [payoutMethodType.mutations.SET_PAYOUT_METHODS_LIST]: (
    state,
    states: Array<PayoutMethods>
  ) => {
    const payoutMethods: Array<PayoutMethods> = states;

    state.payoutMethodsList = payoutMethods;
  },
};

const actions: ActionTree<PayoutMethodState, RootState> = {
  [payoutMethodType.actions.PAYOUT_METHODS_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/payout-methods')
        .then((res: AxiosResponse) => {
          commit(
            payoutMethodType.mutations.SET_PAYOUT_METHODS_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
